<template>
  <div class="flex justify-center">
    <span v-for="ticket in ticketsJson" :key="'tickets-cell-' + ticket.id">
      <a target="_blank" :href="'/tickets/' + ticket.id">
        <plant-issues
          class="fa-rotate-45-left ml-1"
          :severity="ticket.closed_on ? 'NOK' : 'OK'"
          type="ticket"
          v-tooltip.top="ticket.title"
        />
      </a>
    </span>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { TicketJson } from '@/data/tickets/TicketJson.ts';
import PlantIssues from '@/presentation/components/status/icon/PlantIssues.vue';

export default {
  name: 'TicketsCell',
  props: {
    ticketsJson: { type: Array as PropType<TicketJson[]>, default: () => [] },
  },
  components: { PlantIssues },
};
</script>

<style scoped></style>
